import React from 'react';
import {Link} from 'react-router-dom'
import styled from 'styled-components';
import Logo from '@/assets/logo.svg';
import { breakpoints } from '@/layouts/breakpoints'

const StyledComp = styled.section`
  display: grid;
  grid-template-columns: 0.85fr 1fr;
  gap: 64px;
  align-items: start;
  max-width: 1400px;
  margin: 0 auto;
  padding: 120px 40px;
  color: #1a1a1a;

  h2 {
    margin: 0;
    font-size: 60px;
    line-height: 1.5;
    letter-spacing: -0.01em;

    @media (max-width: ${breakpoints.medium}) {
      font-size: 32px;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .media {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    background: var(--grey);
  }

  .media .hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  opacity: 0.4;
  }

  .badges {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 10px;

  }

  .badge {
    width: 64px;
    height: 64px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  }

  .badge img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  .badge--orange {
    background: #d97a4d;
  }

  .badge--dark {
    background: #16140f;
  }

  .badge--white {
    background: #ffffff;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18), inset 0 0 0 1px rgba(0, 0, 0, 0.06);
  }

  .description {
    margin: 0;
    font-size: 15px;
    line-height: 1.55;
    color: #6b6862;
  }

  .included {
    margin: 0;
    font-size: 15px;
    line-height: 1.5;
    color: #1a1a1a;
  }

  .learn-more {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    text-decoration: none;
    width: fit-content;
  }

  .learn-more svg {
    width: 14px;
    height: 14px;
    transition: transform 0.15s ease;
  }

  .learn-more:hover svg {
    transform: translateX(3px);
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 40px 24px;
  }
`;

const Comp = () => {
  return (
    <StyledComp>
      <div className="left">
        <h2 className="serif">
          Financial data SDKs
          <br />inside
          Claude and
          <br />
          ChatGPT
        </h2>
      </div>

      <div className="right">
        <div className="media">
          <img className="hero-image" src="/ls.webp" alt="AxionQuant AI assistant interface" width="700" height="700" fetchPriority="high" />

          <div className="badges">
            <div className="badge badge--dark">
              <img src="/devs/claude-icon.svg" alt="Claude" width="28" height="28" />
            </div>
            <div className="badge badge--white">
              <img src={Logo} alt="Axion" width="28" height="28" />
            </div>
            <div className="badge  badge--orange">
              <img src="/devs/openai-icon.svg" alt="ChatGPT" width="28" height="28" />
            </div>
          </div>
        </div>

        <p className="description">
          Access daily and historical market data, filings, and transcripts through a quant research API inside your conversation, and move seamlessly from raw inputs to research, correlation, and strategy in one flow.
        </p>

        <p className="included">Combine AxionQuant's financial data API with any external dataset for deeper analysis, all in a single workspace.</p>

        <Link className="learn-more" to="/dashboard/mcp">
          Configure tools
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 6l6 6-6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    </StyledComp>
  );
};

export default Comp;
